import { SyncFormFormFields, TSyncSpecificProductFormValues } from '../helpers';
import { IAkeneoSyncSpecificProductDTO } from '@/models/akeneoSync.model';

class SyncSpecificProductDTO implements IAkeneoSyncSpecificProductDTO {
  channelSlug: string;

  sku: string;

  constructor(values: TSyncSpecificProductFormValues) {
    this.channelSlug = values[SyncFormFormFields.CHANNEL];
    this.sku = values[SyncFormFormFields.SKU];
  }
}

export default SyncSpecificProductDTO;
